import React, { Fragment, useState } from 'react';
import H3FormInput from '@Uilib/h3FormInput';
import '../EwaybillForm/style.scss';
import {
  Alert, DatePicker, Divider, notification, Radio, Select,
} from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faPlane, faShip, faTrain, faTruck,
} from '@fortawesome/free-solid-svg-icons';
import H3Text from '@Uilib/h3Text';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import { toISTDate, IndianStates } from '@Apis/constants';
import EinvoiceEwaybillIntegrationActions from '@Actions/integrations/einvoiceEwaybillActions';
import { PropTypes } from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import dayjs from 'dayjs';
import SelectSeller from '../../../../Common/SelectSeller';
import PRZSelect from '../../../../Common/UI/PRZSelect';

const { Option } = Select;

const TransporterDrawer = ({
  addTransporterLoading, addTransporter, selectedEwaybill, user, callback,
}) => {
  const [modeOfTransport, setModeofTransport] = useState('Road');
  const [vehicleType, setVehicleType] = useState(1);
  const [vehicleNumber, setVehicleNumber] = useState('');
  const [transporterDocNumber, setTransporterDocNumber] = useState('');
  const [selectedTransporterDocDate, setSelectedTransporterDocDate] = useState(null);
  const [states, setStates] = useState('');
  const [place, setPlace] = useState('');
  const [reasons, setReasons] = useState('');
  const [remarks, setRemarks] = useState('');
  const [formSubmitted, setFormSubmitted] = useState(false);
  const indianStateOptions = IndianStates?.map((ctr) => ({
    label: ctr.name?.toProperCase(),
    value: ctr.name,
  }));
  const reasonOptions = [
    { label: 'Due to Break Down', value: 'DUE TO BREAK DOWN' },
    { label: 'Due to Trans-Shipment', value: 'DUE TO TRANSHIPMENT' },
    { label: 'First Time', value: 'FIRST TIME' },
    { label: 'Others', value: 'OTHERS (PLS. SPECIFY)' },
  ];

  return (
    <div>
      <div className="ewaybill-form__wrapper" style={{ paddingTop: 'unset' }}>
        <div className="ant-row">
          <div className="ant-col-md-24">
            <div>
              <div className="ewaybill-form__header">
                <div className="ant-row">
                  <div className="ant-col-md-24 ant-col-xs-24">
                    <div className="ewaybill-form__header-row">
                      <div className="ewaybill-form__input-row__label">
                        Mode Of Transport
                      </div>
                      <div className="ewaybill-form__input-row__input">
                        <div className="resources-create__type-section">
                          <Radio.Group buttonStyle="solid" onChange={(e) => { setModeofTransport(e.target.value); }} value={modeOfTransport}>
                            <Radio.Button value="Road">
                              Road
                            </Radio.Button>
                            <Radio.Button value="Rail">
                              Rail
                            </Radio.Button>
                            <Radio.Button value="Air">
                              Air
                            </Radio.Button>
                            <Radio.Button value="Ship">
                              Ship
                            </Radio.Button>
                          </Radio.Group>
                        </div>
                      </div>
                    </div>
                    <div className="ewaybill-form__header-row" style={{ margin: '20px 0px' }}>
                      <div className="ewaybill-form__input-row__label">
                        Vehicle Type
                      </div>
                      <div className="ewaybill-form__input-row__input">
                        <Radio.Group
                          disabled={addTransporterLoading || ['Rail', 'Air', 'Ship'].includes(modeOfTransport)}
                          onChange={(e) => { setVehicleType(e.target.value); }}
                          value={vehicleType}
                        >
                          <Radio value={1}>Regular</Radio>
                          <Radio value={2}>Over dimensional Cargo </Radio>
                        </Radio.Group>
                      </div>
                    </div>
                    <div className="ewaybill-form__header-row">
                      <div className="ewaybill-form__input-row__label">
                        Vehicle Number
                        {modeOfTransport === 'Road' && <span style={{ color: 'red', marginLeft: '3px' }}>*</span>}
                      </div>
                      <div className="ewaybill-form__input-row__input">
                        <H3FormInput
                          name="Vehicle Number"
                          type="text"
                          containerClassName="orgInputContainer "
                          inputClassName="orgFormInput  "
                          onChange={(e) => setVehicleNumber(e.target.value)}
                          value={vehicleNumber}
                          showError={formSubmitted && modeOfTransport === 'Road' && !vehicleNumber}
                          required
                          disabled={addTransporterLoading || modeOfTransport !== 'Road'}
                        />
                      </div>
                    </div>
                    <div className="ewaybill-form__header-row">
                      <div className="ewaybill-form__input-row__label">
                        From State
                        <span style={{ color: 'red', marginLeft: '3px' }}>*</span>
                      </div>
                      <div className="ewaybill-form__input-row__input" style={{ fontSize: '12px', marginBottom: '10px' }}>
                        <PRZSelect
                          value={states}
                          disabled={addTransporterLoading}
                          showSearch
                          onChange={(value) => {
                            setStates(value);
                          }}
                          options={indianStateOptions}
                        />
                      </div>
                    </div>
                    <div className="ewaybill-form__header-row">
                      <div className="ewaybill-form__input-row__label">
                        From Place
                        <span style={{ color: 'red', marginLeft: '3px' }}>*</span>
                      </div>
                      <div className="ewaybill-form__input-row__input">
                        <H3FormInput
                          name="Place"
                          type="text"
                          containerClassName="orgInputContainer "
                          inputClassName="orgFormInput  "
                          onChange={(e) => setPlace(e.target.value)}
                          value={place}
                          showError={formSubmitted && !place}
                        />
                      </div>
                    </div>
                    <H3FormInput
                      label={(
                        <Fragment>
                          {modeOfTransport === 'Road' && <Fragment>Transporter's Doc Number</Fragment>}
                          {modeOfTransport === 'Rail' && <Fragment>RR Number</Fragment>}
                          {modeOfTransport === 'Air' && <Fragment>Airway Bill Number</Fragment>}
                          {modeOfTransport === 'Ship' && <Fragment>Bill of Landing Number</Fragment>}
                        </Fragment>
                      )}
                      name={(
                        <div>
                          {modeOfTransport === 'Road' && <div>Transporter&apos;s Doc Number</div>}
                          {modeOfTransport === 'Rail' && <div>RR Number</div>}
                          {modeOfTransport === 'Air' && <div>Airway Bill Number</div>}
                          {modeOfTransport === 'Ship' && <div>Bill of Landing Number</div>}
                        </div>
                      )}
                      type="text"
                      labelClassName="ewaybill-form__input-row__label"
                      containerClassName="ewaybill-form__header-row"
                      inputClassName="ewaybill-form__input-row__input orgFormInput"
                      onChange={(e) => setTransporterDocNumber(e.target.value)}
                      value={transporterDocNumber}
                      // showError={formSubmitted && (gstNumber ? String(gstNumber)?.length === 15 : false)}
                      disabled={addTransporterLoading}
                      required={modeOfTransport !== 'Road' && !transporterDocNumber}
                    />
                    <div className="ewaybill-form__header-row" style={{ marginTop: '22px' }}>
                      <div className="ewaybill-form__input-row__label">
                        Select a Reason
                        <span style={{ color: 'red', marginLeft: '3px' }}>*</span>
                      </div>
                      <div className="ewaybill-form__input-row__input" style={{ fontSize: '12px' }}>
                        <PRZSelect
                          value={reasons}
                          disabled={addTransporterLoading}
                          showSearch
                          onChange={(value) => {
                            setReasons(value);
                          }}
                          options={reasonOptions}
                        />
                      </div>
                    </div>
                    <div className="ewaybill-form__header-row" style={{ marginTop: '22px' }}>
                      <div className="ewaybill-form__input-row__label">
                        Remarks
                      </div>
                      <div className="ewaybill-form__input-row__input">
                        <H3FormInput
                          name="Remarks"
                          type="text"
                          containerClassName="orgInputContainer "
                          inputClassName="orgFormInput  "
                          onChange={(e) => setRemarks(e.target.value)}
                          value={remarks}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="ewaybill-form__wrapper__footer">

          <H3Button
            text="Add Transport Details"
            buttonType={defaultButtonTypes.BLUE_ROUNDED}
            customClass="ewaybill-form__wrapper__footer-submit"
            onClick={() => {
              setFormSubmitted(true);
              if ((modeOfTransport === 'Road' && !vehicleNumber) || (modeOfTransport !== 'Road' && !transporterDocNumber) || !reasons || !states || !place) {
                notification.open({
                  message: 'Please provide all mandatory inputs',
                  placement: 'top',
                  duration: 4,
                  type: 'error',
                });
              } else {
                const payload = {
                  tenant_id: user?.tenant_info?.tenant_id,
                  ewb_no: selectedEwaybill?.ewb_no,
                  ewb_id: selectedEwaybill?.ewb_id,
                  transportation_doc_number: transporterDocNumber,
                  transportation_doc_date: dayjs(selectedEwaybill?.document_date).format('DD/MM/YYYY'),
                  vehicle_number: vehicleNumber?.replaceAll(' ', ''),
                  vehicle_type: vehicleType === 1 ? 'R' : 'O',
                  transportation_mode: modeOfTransport,
                  remark: remarks,
                  reason: reasons,
                  state: states,
                  place,
                };
                addTransporter(payload, () => { callback(); });
              }
            }}
            isLoading={
              addTransporterLoading
            }
            disabled={
              addTransporterLoading
            }
          />
        </div>
      </div>

    </div>
  );
};
const mapStateToProps = ({ EinvoiceEwaybillReducers, UserReducers }) => ({

  user: UserReducers.user,
  addTransporterLoading: EinvoiceEwaybillReducers.addTransporterLoading,
});

const mapDispatchToProps = (dispatch) => ({
  addTransporter: (payload, callback) => dispatch(EinvoiceEwaybillIntegrationActions.addTransporter(payload, callback)),
});

TransporterDrawer.propTypes = {
  user: PropTypes.any,
  addTransporterLoading: PropTypes.bool,
  addTransporter: PropTypes.func,
  drawermode: PropTypes.any,
  selectedEwaybill: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(TransporterDrawer));
